module.exports = {
	siteName: 'login',
	appI18nConfig: {
		defaultLocale: 'xx',
		supportedLocales: ['en', 'it', 'fr', 'xx'],
	},
};